<template>
  <div
    ref="kt_modal_produto_detalhes"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade"
    data-bs-keyboard="false"
    v-modal-drag
    tabindex="-1"
    id="kt_modal_produto_detalhes"
  >
    <div
      class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen025.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Detalhes do Produto</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarProdutoDetalhes(false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="col-12 mb-2">
            <div class="mb-6">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">{{
                  this.retornaLabelDescricao(
                    "79a00056-12d0-4c8f-b3f4-d95d183ff7f6"
                  )
                }}</label>
              </div>
              <select
                :id="`FaturamentoItemDetPesagem`"
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.detPesagem"
              >
                <template v-for="pesagem in this.pesagens" :key="pesagem">
                  <option
                    :value="pesagem.descricao"
                    v-bind:selected="[
                      pesagem.descricao === this.detPesagem ? 'selected' : '',
                    ]"
                  >
                    {{ pesagem.descricao }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="mb-6">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">{{
                  this.retornaLabelDescricao(
                    "685ed62c-38c5-4fb3-a1aa-bf63265d324d"
                  )
                }}</label>
              </div>
              <select
                :id="`FaturamentoItemDetTolerancia`"
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.detTolerancia"
              >
                <template
                  v-for="tolerancia in this.tolerancias"
                  :key="tolerancia"
                >
                  <option
                    :value="tolerancia.descricao"
                    v-bind:selected="[
                      tolerancia.descricao === this.detTolerancia
                        ? 'selected'
                        : '',
                    ]"
                  >
                    {{ tolerancia.descricao }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="mb-6">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">{{
                  this.retornaLabelDescricao(
                    "056ce5f8-b997-4a72-85c9-f8162c6139da"
                  )
                }}</label>
              </div>
              <select
                :id="`FaturamentoItemDetTipoEmbalagem`"
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.detTipoEmbalagem"
              >
                <template
                  v-for="tipoEmbalagem in this.tipoEmbalagens"
                  :key="tipoEmbalagem"
                >
                  <option
                    :value="tipoEmbalagem.descricao"
                    v-bind:selected="[
                      tipoEmbalagem.descricao === this.detTipoEmbalagem
                        ? 'selected'
                        : '',
                    ]"
                  >
                    {{ tipoEmbalagem.descricao }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="mb-6">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">{{
                  this.retornaLabelDescricao(
                    "b5be0812-fe1b-465d-8757-d7599ad55464"
                  )
                }}</label>
              </div>
              <select
                :id="`FaturamentoItemDetCodBarras`"
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.detCodBarras"
              >
                <template v-for="codBarra in this.codBarras" :key="codBarra">
                  <option
                    :value="codBarra.descricao"
                    v-bind:selected="[
                      codBarra.descricao === this.detCodBarras
                        ? 'selected'
                        : '',
                    ]"
                  >
                    {{ codBarra.descricao }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="mb-6">
              <div class="d-flex justify-content-between">
                <label class="form-label me-4">{{
                  this.retornaLabelDescricao(
                    "0b1beec4-f93b-4150-b2ba-5eaa93e51159"
                  )
                }}</label>
              </div>
              <select
                :id="`FaturamentoItemDetMetragem`"
                class="form-select mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.detMetragem"
              >
                <template v-for="metragem in this.metragens" :key="metragem">
                  <option
                    :value="metragem.descricao"
                    v-bind:selected="[
                      metragem.descricao === this.detMetragem ? 'selected' : '',
                    ]"
                  >
                    {{ metragem.descricao }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarProdutoDetalhes(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            type="button"
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
export default {
  emits: ["exibirModalEditarProdutoDetalhes", "confirmarDetalhesProduto"],
  props: {
    detPesagemItem: { type: String, require: true },
    detToleranciaItem: { type: String, require: true },
    detTipoEmbalagemItem: { type: String, require: true },
    detCodBarrasItem: { type: String, require: true },
    detMetragemItem: { type: String, require: true },
  },
  methods: {
    async confirmar() {
      this.$emit(
        "confirmarDetalhesProduto",
        this.detPesagem,
        this.detTolerancia,
        this.detTipoEmbalagem,
        this.detCodBarras,
        this.detMetragem
      );
    },
    async carregarLabelDescricao() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$select=campo,descricao&$filter=modulo eq 'Pedidos' or modulo eq 'Produtos'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricao = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    retornaLabelDescricao(campo) {
      var label = this.labelDescricao.find(
        (element) => element.campo === campo
      );
      return label ? label.descricao : "";
    },
    async carregarPedidoItemDetPesagens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetPesagem/getPedidoItemDetPesagemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.pesagens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetTolerancias() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetTolerancia/getPedidoItemDetToleranciaOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tolerancias = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetTipoEmbalagens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetTipoEmbalagem/getPedidoItemDetTipoEmbalagemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tipoEmbalagens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetCodBarras() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetCodBarras/getPedidoItemDetCodBarrasOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.codBarras = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetMetragens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetMetragem/getPedidoItemDetMetragemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.metragens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalEditarProdutoDetalhes(exibir) {
      this.$emit("exibirModalEditarProdutoDetalhes", exibir);
    },
  },
  async mounted() {
    this.detPesagem = this.detPesagemItem;
    this.detTolerancia = this.detToleranciaItem;
    this.detTipoEmbalagem = this.detTipoEmbalagemItem;
    this.detCodBarras = this.detCodBarrasItem;
    this.detMetragem = this.detMetragemItem;

    await this.carregarLabelDescricao();
    await this.carregarPedidoItemDetPesagens();
    await this.carregarPedidoItemDetTolerancias();
    await this.carregarPedidoItemDetTipoEmbalagens();
    await this.carregarPedidoItemDetCodBarras();
    await this.carregarPedidoItemDetMetragens();
  },
  data() {
    return {
      detPesagem: "",
      detTolerancia: "",
      detTipoEmbalagem: "",
      detCodBarras: "",
      detMetragem: "",
      labelDescricao: [],
      pesagens: [],
      tolerancias: [],
      tipoEmbalagens: [],
      codBarras: [],
      metragens: [],
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
